const realpressContactForm = () => {
	const contactButtonNode = document.querySelector( '.realpress-agent-detail-contact button' );
	const contactFormNode = document.querySelector( '.realpress-agent-contact-form' );
	if ( ! contactButtonNode || ! contactFormNode ) {
		return;
	}
	contactButtonNode.addEventListener( 'click', function() {
		contactFormNode.style.display = 'block';
	} );

	contactFormNode.querySelector( '.realpress-agent-contact-form-close' ).addEventListener( 'click', function() {
		contactFormNode.style.display = 'none';
	} );

	document.addEventListener( 'click', function( event ) {
		if ( event.target === contactFormNode ) {
			contactFormNode.style.display = 'none';
		}
	} );
	const formNode = contactFormNode.querySelector( 'form.realpress-contact-form' );
};

export default realpressContactForm;
